interface UseDownloadPdfHookOutput {
	downloadPdf: (base64: string, documentName: string) => void;
	base64toBlob: (base64Data: any, isZip?: boolean) => Blob;
}

export const useDownloadPdf = (): UseDownloadPdfHookOutput => {
	const base64toBlob = (base64Data: any, isZip = false): Blob => {
		const sliceSize = 1024;
		const byteCharacters = atob(base64Data);
		const bytesLength = byteCharacters.length;
		const slicesCount = Math.ceil(bytesLength / sliceSize);
		const byteArrays = new Array(slicesCount);

		for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			const begin = sliceIndex * sliceSize;
			const end = Math.min(begin + sliceSize, bytesLength);

			const bytes = new Array(end - begin);
			for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: isZip ? 'application/zip' : 'application/pdf' });
	};

	const downloadPdf = (base64: string, documentName: string) => {
		const blob = base64toBlob(base64, false);
		const data = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = data;
		link.download = `${documentName}`;
		setTimeout(() => {
			window.open(data);
		});
		setTimeout(function (): void {
			window.URL.revokeObjectURL(data);
		}, 100);
	};

	return { downloadPdf, base64toBlob };
};
